import type { AppRoute } from '@/constants/routes'

/**
 * Build a concrete path from a route template, substituting :params.
 * Throws if a required param is missing — a missing id is a bug, not a silent
 * broken link.
 */
export function buildPath(route: AppRoute, params: Record<string, string | number> = {}): string {
  return route.replace(/:([A-Za-z0-9_]+)/g, (_match, key: string) => {
    const value = params[key]
    if (value === undefined) {
      throw new Error(`buildPath: missing route param "${key}" for "${route}"`)
    }
    return encodeURIComponent(String(value))
  })
}

/** Parse a URLSearchParams / query string into a flat string record. */
export function parseQueryParams(search: string | URLSearchParams): Record<string, string> {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search
  const result: Record<string, string> = {}
  params.forEach((value, key) => {
    result[key] = value
  })
  return result
}
